export default "__VITE_ASSET__DN0jIHH2__"